<template>
  <div class="bar">
    <div class="nav">
      <div class="nav-left" @click="onInputClick">
        <img class="nav-search-icon" src="@/assets/images/course/search-icon.png"/>
        <input
          class="nav-search"
          v-model="value"
          :placeholder="$t('app_searchPrompt')"
        />
      </div>
      <div class="nav-right" @click="checkSort">
        <div class="nav-sel">{{ $t(names[selectIndex]) }}</div>
        <van-icon class="nav-exp" :name="show ? 'arrow-up' : 'arrow-down'" color="#030303" size="14px" />
      </div>
    </div>
  </div>
  <van-popup style="top: 44px" v-model:show="show" position="top" :style="{ height: '150px' }">
    <div class="pop-content">
      <div
        class="pop-item"
        :class="{ active: selectIndex === index }"
        v-for="(item, index) in list"
        :key="item.sortType"
        @click="onSort(index)"
      >
        {{ $t(names[index]) }}
      </div>
    </div>
  </van-popup>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { useThemeColor } from '@/utils/theme'

const props = defineProps({
  activeIndex: {
    type: Number,
    default: 0
  }
})

const emits = defineEmits(['onInputClick', 'onSort'])
const themeColor = useThemeColor()
const value = ref('')
const show = ref(false)
const names = ['app_publish_time', 'app_update_time', 'app_learning_count']
const list = [{ sortType: 1 }, { sortType: 2 }, { sortType: 3 }]
const selectIndex = ref(props.activeIndex || 0)
const checkSort = () => {
  show.value = !show.value
}
const onInputClick = () => {
  emits('onInputClick')
}
const onSort = (index: number) => {
  selectIndex.value = index
  show.value = !show.value
  emits('onSort', list[selectIndex.value])
}

watch(
  () => props.activeIndex,
  (newValue) => {
    selectIndex.value = newValue
  }
)
</script>

<style scoped lang="less">
.bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
}
.nav {
  width: 100vw;
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 44px;
  justify-content: space-between;
  background: #fff;
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  .nav-left {
    width: 225px;
    height: 33px;
    display: flex;
    align-items: center;
    border: 1px solid #e1e1e1;
    border-radius: 16px;
  }
  .nav-search-icon {
    width: 17px;
    height: 17px;
    margin: 0 12px;
  }
  .nav-search {
    flex: 1;
    height: 100%;
    background: none;
    outline: none;
    border: none;
    font-size: 12px;
    color: #171921;
  }
  .nav-search::placeholder {
    color: #b7b7b7;
  }
  .nav-right {
    font-size: 14px;
    color: #171921;
    display: flex;
    align-items: center;
  }
  .nav-sel {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex: 1;
    margin-left: 4px;
  }
  .nav-exp {
    margin-left: 6px;
  }
}
.pop-content {
  padding-left: 16px;
}
.pop-item {
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #171921;
  border-bottom: 1px solid #f0f0f0;
}
.active {
  color: v-bind(themeColor);
}
</style>
